import React from 'react'
import {Link} from 'react-router-dom'

const ComedyMobCard = ({item,index,catId}) => {

    const isTelugu = (text) => /[\u0C00-\u0C7F]/.test(text);
 
  return (
    <div className={`comedy-mob-card`}>
   
    <Link to={item.url_link ? item.url_link.substring(item.url_link.indexOf('/content')) : ''}  >
  
       <div className='comedy-mob-card-img-container'>
       <img loading={(index <= 2 && catId ===71) ? 'eager' : 'lazy'} fetchpriority={(index === 0 && catId === 71) ? 'high' :'auto'} src={item.stimg ? item.stimg : '/comedy/assets/images/error_img.webp'} alt="comedy-mob-card-img" />
       </div>
       <div className='comedy-mob-card-title-container'>
       <h4 className={`comedy-mob-card-title ${isTelugu(item.title) && item.title ? "comedy-mob-card-title-tl" : 'comedy-mob-card-title-en'}`}>{item.title ? item.title : ''}</h4>
       <p    dangerouslySetInnerHTML={{__html : (item.description ? item.description : '')}} />{<button type='button'>View Content</button>}</div>
     
    
    </Link>


    </div>
  )
}

export default ComedyMobCard;